import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { Button } from "../../../design-system/components/primitives/Button/Button";

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  width: 100%;
  min-width: 0;
`;
export const Field = styled.input`
  flex: 1 1 0%;
  min-width: 0;
  height: ${spacing[10]};
  padding: 0 ${spacing[3]};
  box-sizing: border-box;
  border: 1.5px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.xl};
  background: ${rawColors.grey[50]};
  color: ${rawColors.text.mediumEmphasis};
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  ${typographyMixin("caption", 3)}
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: auto;
`;
export const CopyButton = styled(Button)`
  &&& {
    height: ${spacing[10]};
    min-height: ${spacing[10]};
    padding: 0 ${spacing[5]};
    border-radius: ${borderRadius.full};
    white-space: nowrap;
    flex: 0 0 auto;
  }
`;
